/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs */



/**
* | output |
* | --- |
* | "Move the Event position right 1 character" |
*
* @param {Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_cc_move_right_one_character = /** @type {((inputs?: Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Cc_Move_Right_One_CharacterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer la position de l'evenement d'un caractere vers la droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschieben Sie die Ereignisposition um ein Zeichen nach rechts.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la posizione dell'evento di 1 carattere a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите позицию события на один символ вправо.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mueva la posición del evento 1 carácter a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件位置向右移动一个字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの位置を1文字右に移動する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की स्थिति को 1 वर्ण दाएं ले जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mova a posição do evento um caractere para a direita.")
	return /** @type {LocalizedString} */ ("Move the Event position right 1 character")
});